import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsTime'
})
export class SecondsTimePipe implements PipeTransform {

  transform(seconds: number, ...args: unknown[]): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return (m > 0 ? (m + 'm ') : '') + (s > 0 ? (s + 's') : '');
  }

}
